const slice = (o, n) => Array.prototype.slice.call(o, n);

export { slice };
